module.exports = __webpack_public_path__ + "static/media/chorthippus_dorsatus_004_APA.ddcc82ac.mp3";